module.exports = __webpack_public_path__ + "img/aqfh-img-25.19af684e.png";